import React from 'react';
import { Link } from 'react-router-dom';
import { useStrapiPosts } from '../hooks/useStrapiPosts';

export default function Blog() {
  const { posts, loading, error } = useStrapiPosts();

  return (
    <div className="bg-white min-h-screen py-20 px-6">
      <div className="max-w-6xl mx-auto space-y-10">
        <header className="space-y-3 text-center">
          <p className="text-xs uppercase tracking-[0.6em] text-gray-500">Insights</p>
          <h1 className="text-4xl font-bold text-charcoal">Tax Strategy Center Blog</h1>
          <p className="text-gray-600">
            Articles, playbooks, and recordings that keep CPAs and advisors ahead of IRS moves.
          </p>
        </header>

        {loading && (
          <div className="text-center text-gray-500">Loading latest posts…</div>
        )}

        {error && (
          <div className="rounded-3xl border border-red-200 bg-red-50 p-6 text-red-700">
            {error.message || 'Unable to load posts right now.'}
          </div>
        )}

        <div className="grid gap-6 md:grid-cols-2">
          {posts.map((post) => (
            <article
              key={post.slug}
              className="group rounded-3xl border border-gray-200 bg-white shadow-lg transition hover:-translate-y-1 hover:shadow-2xl"
            >
              {post.heroImage && (
                <img
                  src={post.heroImage}
                  alt={post.title}
                  className="h-48 w-full rounded-t-3xl object-cover"
                />
              )}
              <div className="p-6 space-y-3">
                <p className="text-xs uppercase tracking-[0.5em] text-gray-400">
                  {post.publishedAt}
                </p>
                <h2 className="text-2xl font-semibold text-charcoal">{post.title}</h2>
                <p className="text-gray-600 text-sm leading-relaxed">{post.excerpt}</p>
                <Link
                  to={`/blog/${post.slug}`}
                  className="inline-flex items-center text-sm font-semibold text-primary"
                >
                  Read article →
                </Link>
              </div>
            </article>
          ))}
        </div>

        {!loading && (
          <div className="text-center">
            <p className="text-sm text-gray-500">Prefer a guided download?</p>
            <Link
              to="/free-assessment"
              className="mt-3 inline-flex items-center justify-center rounded-full border border-primary px-6 py-3 text-sm font-semibold text-primary"
            >
              Request a playbook + consult
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
